<div class="wrap">
    <h3>Ma licence</h3>
    <div class="loading" *ngIf="loading">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="img" *ngIf="!loading">
        <img [src]="urlPng" alt="ma_licence" *ngIf="urlPng">
    </div>
</div>